__turbopack_context__.v({
  "container": "course-retirement-banner-module-scss-module___F-NbG__container",
});
